export const calculateProgress = (percentage) => {
  return (percentage / 100) * 355;
};
